/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentPostureSummaryResponse {
    getFixupPrototypeFunction() { return AssessmentPostureSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<AssessmentPostureSummaryResponse>): AssessmentPostureSummaryResponse {
        let obj = Object.assign(new AssessmentPostureSummaryResponse(), model);
        AssessmentPostureSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentPostureSummaryResponse>): AssessmentPostureSummaryResponse {
        if (!model) return null;
        return AssessmentPostureSummaryResponse.newInstance(<AssessmentPostureSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentPostureSummaryResponse) {
        if (!obj) return;

        models.AssessmentPostureSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentPostureSummaryResponse): boolean {
        Object.setPrototypeOf(obj, AssessmentPostureSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * compliance governance summary listed successfully
     */
    message: string;

    /**
     * list of assessment posture summary enteries.
     */
    data: any;

}
